
export const getReviews = async (id) => {
    try {
        const response = await fetch(`/rest/api.reviews.get?USER_ID=${id}`);
        // const response = await fetch(`/rest/api.reviews.get/`);

        return response.json();

    } catch (err) {
        console.log(err)
    }
}

export const getComments = async (id) => {
    try {
        const response = await fetch(`/rest/api.comments.get?ID_REVIEW=${id}`);

        return response.json();

    } catch (err) {
        console.log(err)
    }
}

export const updateReview = async (data) => {
    try {
        const response = await fetch('/rest/api.reviews.update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body:JSON.stringify(data)
        });

        return response.json();

    } catch (err) {
        console.log(err)
    }
}